import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Grid } from 'components/ui';
import RecapItem from 'components/Content/Recap/RecapItem';
import RecapImage from 'components/Content/Recap/RecapImage';

const MAX_THUMBNAILS = 4;
const THUMBNAIL_SIZE = [122, 166];

/**
 * Card 3 — "New Markdowns for You" presentational component.
 *
 * Displays up to 4 sale SKU thumbnails in a 2×2 grid
 * Clicking the card navigates to the provided `targetUrl`.
 *
 * @param {Object} props
 * @param {Array} [props.products] - Sale SKUs with image fields
 * @param {string} [props.title] - Card heading
 * @param {string} [props.targetUrl] - Navigation URL on click
 * @param {boolean} [props.isLoading] - Whether the card is in loading state
 * @param {Function} [props.triggerClick] - Click tracking callback
 */
function RecapNewMarkdowns({ products, ...props }) {
    const tiles = Array.isArray(products) ? products.slice(0, MAX_THUMBNAILS) : [];

    return (
        <RecapItem
            {...props}
            displayTitle={props.title}
        >
            <Grid
                columns={2}
                gap={[1, 2]}
            >
                {tiles.map((product, index) => (
                    <div key={product.skuId || index}>
                        <RecapImage
                            sku={product}
                            size={THUMBNAIL_SIZE}
                            showPlaceholderOnError={true}
                        />
                    </div>
                ))}
            </Grid>
        </RecapItem>
    );
}

RecapNewMarkdowns.propTypes = {
    products: PropTypes.array,
    title: PropTypes.string,
    targetUrl: PropTypes.string,
    sid: PropTypes.string,
    isLoading: PropTypes.bool,
    triggerClick: PropTypes.func
};

export default wrapFunctionalComponent(RecapNewMarkdowns, 'RecapNewMarkdowns');
